var __extends = this && this.__extends || function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
            d.__proto__ = b;
        } || function (d, b) {
            for (var p in b)
                if (b.hasOwnProperty(p))
                    d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = this && this.__assign || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Fragment } from 'react';
import classnames from 'classnames';
import './groupInput.less';
var AutoComplete = function (_super) {
    __extends(AutoComplete, _super);
    function AutoComplete(props) {
        var _this = _super.call(this, props) || this;
        _this.handleDocumentClick = function (event) {
            var onClose = _this.props.onClose;
            if (_this.dom && _this.dom === event.target) {
                return;
            }
            onClose();
            return;
        };
        _this.onChange = function (e) {
            var onChange = _this.props.onChange;
            var value = e && e.target ? e.target.value : e;
            onChange(value);
        };
        _this.onSelect = function (e) {
            var onSelection = _this.props.onSelection;
            onSelection(e);
        };
        return _this;
    }
    AutoComplete.prototype.componentDidMount = function () {
        document.addEventListener('click', this.handleDocumentClick);
    };
    AutoComplete.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.handleDocumentClick);
    };
    AutoComplete.prototype.focus = function () {
        this.dom && this.dom.focus();
    };
    AutoComplete.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, required = _a.required, component = _a.component, error = _a.error, message = _a.message, wrapClassName = _a.wrapClassName, prop = _a.prop, type = _a.type, loader = _a.loader, autoCompleteList = _a.autoCompleteList;
        return React.createElement('div', { className: classnames('form-group search-group position-relative', wrapClassName, error && 'has-error') }, label && React.createElement('label', null, label, ' ', required && '*'), component && React.cloneElement(component, __assign(__assign({}, this.props), {
            onChange: this.onChange,
            ref: function (dom) {
                _this.dom = dom;
            }
        })) || React.createElement(Fragment, null, React.createElement('input', __assign({
            id: prop,
            type: type,
            className: 'form-control pl35',
            ref: function (dom) {
                _this.dom = dom;
            }
        }, this.props, { onChange: this.onChange })), loader ? React.createElement('img', {
            src: 'https://rsp-front-end.lessen.com/sources/img/edit-loading.gif',
            className: 'form-control-loading mt-0'
        }) : null, React.createElement('ul', {
            id: prop + 'autoCompleteList',
            style: {
                display: autoCompleteList.length > 0 ? 'block' : 'none',
                color: 'black'
            },
            className: 'dropdown-menu repair-dropdown'
        }, autoCompleteList.map(function (result) {
            return React.createElement('li', { key: result }, React.createElement('a', {
                href: 'javascript:void(0);',
                onClick: function () {
                    return _this.onSelect(result);
                }
            }, React.createElement('label', {
                className: 'badge badge-lg m-0',
                style: { fontSize: '0.75rem' }
            }, result)));
        }))), error && React.createElement('label', { className: 'text-danger ' }, error), message && message);
    };
    return AutoComplete;
}(React.Component);
export default AutoComplete;